import React from 'react'

const MainCursor = () => {
  return (
    <div className="MainCursor"></div>
  )
}

export default MainCursor
